import { compareDates, formatDate } from '../common/formatDate';
import { DATE_FORMAT_ISO_FNS } from '../constants/dateFormats';

export function makeNoSoonerThenValidator<T>(
  errorMsg: T,
  getMinDate: () => string | undefined,
  valueParseFormat?: string,
  canBeEqual: boolean = true,
  dateFormat: string = DATE_FORMAT_ISO_FNS,
) {
  return (value: string) => {
    const minDate = getMinDate();

    if (!minDate) {
      return undefined;
    }

    const compareResult = compareDates({
      dateLeft: formatDate({
        date: value,
        dateFormat,
        parseFormat: valueParseFormat,
      }),
      dateRight: formatDate({ date: minDate, dateFormat }),
    });

    if (compareResult === -1 || (!canBeEqual && compareResult === 0)) {
      return errorMsg;
    }

    return undefined;
  };
}
